import { queryClient } from "@/config/react-query";

import type {
  CampaignDeliveryDateRange,
  OpportunityFetchParams,
  OpportunityGroupBy,
} from "@/types/opportunity";

// Kept apart from opportunities-query so the chat and email mutations can
// refresh opportunity views without pulling in the growth page's modules.

export const opportunityQueryKeys = {
  all: ["opportunities"] as const,
  lists: () => [...opportunityQueryKeys.all, "list"] as const,
  list: (filters: OpportunityFetchParams) =>
    [...opportunityQueryKeys.lists(), filters] as const,
  groupIndexes: () => [...opportunityQueryKeys.all, "groups"] as const,
  groupIndex: (groupBy: OpportunityGroupBy, filters: OpportunityFetchParams) =>
    [...opportunityQueryKeys.groupIndexes(), groupBy, filters] as const,
  details: () => [...opportunityQueryKeys.all, "detail"] as const,
  detail: (opportunityId: string) =>
    [...opportunityQueryKeys.details(), opportunityId] as const,
  activity: (opportunityId: string) =>
    [...opportunityQueryKeys.all, "activity", opportunityId] as const,
  dashboardKPIs: (days: number) =>
    [...opportunityQueryKeys.all, "dashboard-kpis", days] as const,
  campaignMetrics: () =>
    [...opportunityQueryKeys.all, "campaign-metrics"] as const,
  campaignPerformances: (campaignId: string) =>
    [...opportunityQueryKeys.all, "campaign-performance", campaignId] as const,
  campaignPerformance: (
    campaignId: string,
    { startDate, endDate }: CampaignDeliveryDateRange,
  ) =>
    [
      ...opportunityQueryKeys.all,
      "campaign-performance",
      campaignId,
      startDate,
      endDate,
    ] as const,
  lostReasons: () => [...opportunityQueryKeys.all, "lost-reasons"] as const,
};

// Texts and emails sent from Decoda are logged on the recipient's opportunity
// server-side, so its timeline and Last Contact move without a growth write.
export const invalidateOpportunityContactViews = () => {
  queryClient.invalidateQueries({ queryKey: opportunityQueryKeys.lists() });
  queryClient.invalidateQueries({
    queryKey: opportunityQueryKeys.groupIndexes(),
  });
  queryClient.invalidateQueries({ queryKey: opportunityQueryKeys.details() });
  queryClient.invalidateQueries({
    queryKey: [...opportunityQueryKeys.all, "activity"],
  });
};
